<template>
  <FileImageTwoTone
    style="font-size: 40px"
    :two-tone-color="token.colorPrimary"
  />
</template>

<script setup lang="ts">
import { FileImageTwoTone } from "@ant-design/icons-vue";
import { theme } from "ant-design-vue";

const { useToken } = theme;
const { token } = useToken();
</script>

<style scoped lang="scss"></style>
